<template>
  <b-row class="justify-content-md-center" style="margin-top:5%;">
    <b-col cols="6">
      <h3>{{displayTitle()}}</h3>
      <code-selector v-if="!isAnUpdate"></code-selector>
      <div v-if="hasCode() && hasForm()" style="margin-bottom:50px;">
        <b-badge variant="info" v-if="form.is_in_db ">Existe dans la base</b-badge>
        <b-badge variant="danger" v-if="!form.is_in_db">Absent de la base</b-badge>

        <b-badge variant="info" v-if="form.is_in_erp">Existe dans l'ERP</b-badge>
        <b-badge variant="danger" v-if="!form.is_in_erp">Absent de l'ERP</b-badge>
      </div>
      <div v-if="isLoading">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Récupération des données...</span>
      </div>
      <div v-if="hasCode() && base" style="margin-bottom:50px;">
        <reference-form />
      </div>
      <div v-if="hasCode() && loop" style="margin-bottom:50px;">
        <loop-selector />
      </div>
      <div v-if="hasCode() && specificLoop" style="margin-bottom:50px;">
        <div v-if="form.logistic_loop == 'loop_external'">
          <external-form />
        </div>
        <div v-if="form.logistic_loop == 'loop_usual_components'">
          <internal-form />
        </div>
        <div v-if="form.logistic_loop == 'loop_trading'">
          <trading-form />
        </div>
      </div>
      <div v-if="hasCode() && base">
        <b-button @click="displayLoop" variant="primary">Choix de la boucle</b-button>
        <b-button @click="backToIndex()" variant="danger">Annuler</b-button>
      </div>
      <div v-if="loop">
        <b-button @click="displaySpecificForm" variant="primary">Terminer la création</b-button>
        <b-button @click="backToBase()" variant="danger">Retour</b-button>
      </div>
      <div v-if="specificLoop">
        <b-button @click="saveForm" variant="primary">Envoyer</b-button>
        <b-button @click="backToLoop()" variant="danger">Retour</b-button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
// /!\ CODE CONSTRUCTION FOR EMPLACEMENT = ZONE + POS_Y + POS_X + POS_Z
//                                       =  S   +   Z   +   7   +   A
import server from '../../api/server.vue'
import reference from '../../api/reference.vue'
import erp_loader_server from '../../api/erp_loader_server.vue'
import CodeSelector from './CodeSelector.vue'
import LoopSelector from './LoopSelector.vue'
import ReferenceForm from './ReferenceForm.vue'
import ExternalForm from './ExternalForm.vue'
import InternalForm from './InternalForm.vue'
import TradingForm from './TradingForm.vue'
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

export default {
  name: 'KanbanReferenceModal',
  props: [],
  data() {
    return {
      isLoading: false,
      isAnUpdate: false,
      base: true,
      loop: false,
      specificLoop: false
    }
  },
  computed: {
    ...mapGetters(['selectedCode', 'changeOnlyLogistic', 'actualLoop']),
    ...mapGetters({
      form: 'getFormKanban'
    })
  },
  watch: {
    selectedCode(newValue, oldValue) {
      if (_.isEmpty(newValue)) {
        return
      }
      const loop = this.actualLoop ==  'loop_external' ? this.actualLoop : 'loop_usual_components';
      reference.getReference(newValue, loop).then(result => {
        this.form.code = newValue
        result.data.is_in_db = true

        if (!this.isAnUpdate) {
            this.isAnUpdate = true
        }
        erp_loader_server.getReferenceInfos(newValue, process.env.STORE).then(() => {
            result.data.is_in_erp = true
            this.updateFormFromDbData(result.data)
        }).catch(() => {
            result.data.is_in_erp = false
            this.updateFormFromDbData(result.data)
        })
        // Exist in DB, we filled data
        // this.updateFormFromDbData(result.data)
      }).catch(() => {
          console.error("Erreur get reference")
          this.$toasted.error("Reference introuvable")
          this.isAnUpdate = false
          erp_loader_server.getReferenceInfos(newValue, process.env.STORE).then(result => {
            result.data.is_in_erp = true
            this.updateFormFromErpData(result.data)
          }).catch(() => {
              this.$store.commit('resetKanbanForm')
          })
      })
    }
  },
  methods: {
    backToIndex() {
      const loop = this.actualLoop === "loop_external" ? `/loop_supply_external/${this.selectedCode}` : `/loop_supply_internal/${this.selectedCode}`
      this.goTo(loop)
    },
    backToBase() {
      this.base = true
      this.loop = false
    },
    backToLoop() {
      this.loop = true
      this.specificLoop = false
    },
    displayLoop() {
       this.base = false
      this.loop = true
    },
    displaySpecificForm() {
      this.loop = false
      this.specificLoop = true
    },
    hasCode() {
      return !_.isEmpty(this.selectedCode)
    },
    hasForm() {
      return !_.isEmpty(this.form)
    },
    displayTitle() {
      if (this.isAnUpdate === true) {
        return 'MISE À JOUR  [' + this.chunk(this.selectedCode, 3) + ']'
      }
      return "AJOUT D'UNE NOUVELLE REFERENCE"
    },
    productAlreadyExists(result, append = false) {
      let toast = this.$toasted.success(
        `La référence ${this.form.code} est déjà présente dans la boucle ${this.form.logistic_loop}, mise à jour en cours...`,
        {
          theme: 'bubble',
          position: 'top-right',
          duration: 5000,
          }

      )
      this.updateReferenceVue()
    },
    productWasRemoved(result, append = false) {
      let toast = this.$toasted.success(
        `La référence ${this.form.code} était présente dans la boucle ${this.form.logistic_loop} mais est actuellement désactivée`,
        {
          theme: 'bubble',
          position: 'top-right',
          duration: 10000,
          action: {
            text: 'Mettre à jour et Réactiver',
            onClick: (e, toastObject) => {
              this.updateReferenceVue()
            }
          }
        }
      )
    },
    refNotExists(result, append = false) {
      let toast = this.$toasted.success(
        `La référence ${this.form.code} n'existe pas, impossible de l'attribuer à une boucle, veuillez la créer`,
        {
          theme: 'bubble',
          position: 'top-right',
          duration: 10000,
          action: {
            text: 'Créer la référence',
            onClick: (e, toastObject) => {
              this.backToIndex()
            }
          }
        }
      )
    },
    updateReferenceVue() {
      server.updateReference(this.form).then(response => {
        this.makeToast(response.data + ' mise à jour effectuée avec succès')
        this.backToIndex()
      })
    },
    saveForm() {
      server.addNewRef(this.form).then(result => {
        this.makeToast(result.data)
        reference.createKanbanReference(this.form).then(result => {
          if (result.data === 'ALREADY_HERE') {
            this.productAlreadyExists(result.data)
          } else if (result.data === 'ALREADY_HERE_BUT_REMOVED') {
            this.productWasRemoved(result.data)
          } else if (result.data === 'UNKNOWN_REF') {
            this.refNotExists()
          } else {
            this.makeToast(
              this.form.code + ' ajouté à ' + this.form.logistic_loop
            )
            this.backToIndex()
          }
        })
      })
      // }
    },
    getButtonLabel() {
      if (this.action === 'UPDATE') {
        return 'Mettre à jour la référence'
      }
      return 'Ajouter une nouvelle référence'
    },
    updateFormFromErpData(data) {
      let form = {}
      form.weight = data.weight
      form.designation = data.designation
      if (data.emplacement && !_.isEmpty(data.emplacement)) {
        let splitted_emplacement = data.emplacement
        form.pos_x = splitted_emplacement[3]
        form.pos_y = splitted_emplacement[1]
        form.pos_z = splitted_emplacement[4]
        form.zone = splitted_emplacement[0]
      }
      form.supplier = data.supplier
      form.supplier_code = data.supplier_code
    //   form.customs = data.customs
    //   if (_.isEmpty(this.form.customs)) {
    //     form.customs = data.info.customs
    //   }
      form.is_in_erp = data.is_in_erp
      form.is_in_db = data.is_in_db
      this.$store.commit('updateKanbanForm', form)
    },
    updateFormFromDbData(data) {
      let form = {}
      form.weight = data.weight
      form.designation = data.designation
      form.pos_x = data.pos_x
      form.pos_y = data.pos_y
      form.pos_z = data.pos_z
      form.zone = data.zone
      form.supplier = data.supplier
      form.ranking = data.ranking
      form.supplier_code = data.supplier_code
      form.customs = data.customs
      form.nbr_card = data.nbr_card
      form.batch_size = data.batch_size
      form.logistic_loop = data.logistic_loop
      form.is_in_erp = data.is_in_erp
      form.is_in_db = data.is_in_db
      this.$store.commit('updateKanbanForm', form)
    }
  },
  mounted: function() {
    if (!_.isEmpty(this.$route.params.reference)) {
      this.isAnUpdate = true
      this.$store.commit('setSelectedCode', this.$route.params.reference)
      this.form.code = this.selectedCode
    } else {
      this.isAnUpdate = false
    }
    if (this.changeOnlyLogistic) {
      this.displayLoop()
    }
  },
  components: {
    CodeSelector,
    ReferenceForm,
    LoopSelector,
    ExternalForm,
    InternalForm,
    TradingForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/kanban/KanbanReferenceModal.vue